import type { RouteRecordRaw } from 'vue-router'

const publicRoutes: RouteRecordRaw[] = [
  {
    path: '/welcome',
    name: 'welcome',
    meta: {
      title: 'Welcome to Labour Hub',
    },
    component: () =>
      import(/* webpackChunkName: "welcome" */ '../../views/SplashPage.vue'),
  },
  {
    path: '/demo',
    name: 'demo',
    meta: { title: 'Demo' },
    component: () =>
      import(/* webpackChunkName: "demo" */ '../../views/DemoPage.vue'),
  },
  {
    path: '/:pathMatch(.*)*',
    name: '404',
    meta: { title: '404' },
    component: () =>
      import(/* webpackChunkName: "404" */ '../../views/errors/404Page.vue'),
  },
]

export default publicRoutes
